"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Compare = void 0;
const flow_connect_1 = require("flow-connect");
const core_1 = require("flow-connect/core");
class Compare extends core_1.Node {
    constructor() {
        super();
    }
    setupIO() {
        this.addTerminals([
            { type: core_1.TerminalType.IN, name: "x", dataType: "any" },
            { type: core_1.TerminalType.IN, name: "y", dataType: "any" },
            { type: core_1.TerminalType.OUT, name: "result", dataType: "boolean" },
        ]);
    }
    created(options) {
        const { width = 150, name = "Compare", style = {}, state = {} } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.state = Object.assign(Object.assign({}, Compare.DefaultState), state);
        this.setupUI();
        this.setupListeners();
    }
    process(inputs) {
        if (!(0, flow_connect_1.exists)(inputs[0]) || !(0, flow_connect_1.exists)(inputs[1]))
            return;
        let res;
        switch (this.state.value) {
            case "==": {
                res = inputs[0] == inputs[1];
                break;
            }
            case "===": {
                res = inputs[0] === inputs[1];
                break;
            }
            case "!=": {
                res = inputs[0] != inputs[1];
                break;
            }
            case "!==": {
                res = inputs[0] !== inputs[1];
                break;
            }
            case "<": {
                res = inputs[0] < inputs[1];
                break;
            }
            case "<=": {
                res = inputs[0] <= inputs[1];
                break;
            }
            case ">": {
                res = inputs[0] > inputs[1];
                break;
            }
            case ">=": {
                res = inputs[0] >= inputs[1];
                break;
            }
            case "&&": {
                res = inputs[0] && inputs[1];
                break;
            }
            case "||": {
                res = inputs[0] || inputs[1];
                break;
            }
            default:
                res = false;
        }
        this.setOutputs(0, res);
    }
    setupUI() {
        const select = this.createUI("core/select", {
            values: ["==", "===", "!=", "!==", "<", "<=", ">", ">=", "&&", "||"],
            propName: "value",
            input: true,
            output: true,
            height: 15,
            style: { fontSize: "14px" },
        });
        this.ui.append(select);
    }
    setupListeners() {
        this.watch("value", () => this.process(this.getInputs()));
    }
}
exports.Compare = Compare;
Compare.DefaultState = { value: "==" };
